<template>

  <div class="page-wrap">
    <Header></Header>

    <div class="apply-area flex-r-center">
      <el-card class="box-card mb20 mt20 ml20 mr20">
        <div slot="header" class="card-wrap flex-center-center fz24">
          企业认证
        </div>
        <el-form
            style="padding: 20px 75px"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            class="demo-ruleForm"
            v-loading="loading"
        >

          <div class="upload-image">
            <div class="fz14 top-text">
              <div class="mb5" style="width: 100px">
                <span style="color: red" class="mr5">*</span>上传材料：
              </div>
              <div class="fc-407FFF pointer" @click="checkExampleDia">查看示例</div>
            </div>
            <el-form-item label-width="0px" prop="businessLicenseId">
              <el-input style="display: none" v-model="ruleForm.businessLicenseId"></el-input>
              <el-upload
                  class="avatar-uploader"
                  multiple
                  :show-file-list="false"
                  :before-upload="(e) => handleBeforeUpload(e, 2)"
                  :on-change="onChangeFront"
                  action="/"
                  accept="image/*"
              >
                <img class="image-card" v-if="imageLicenseId" :src="imageLicenseId" alt/>
                <img
                    class="icon-check"
                    v-if="imageLicenseId"
                    @click.stop="checkImage('license')"
                    src="@/assets/login/icon-check-img.png"
                    alt
                />
                <img
                    v-if="!imageLicenseId"
                    src="@/assets/login/image-card-official.png"
                    alt
                />
                <span v-if="!imageLicenseId" class="fz14 fc9">上传单位营业执照</span>
              </el-upload>
            </el-form-item>
          </div>

          <el-row>
            <el-col :span="12">
              <el-form-item prop="businessCreditCode" label="信用代码">
                <el-input
                    @blur="getBlur"
                    v-model="ruleForm.businessCreditCode"
                    placeholder="请输入信用代码"
                >
                </el-input>
              </el-form-item>
              <div class="prompt">请对比信用代码识别的准确性</div>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="businessName" label="单位名称">
                <el-input
                    v-model="ruleForm.businessName"
                    placeholder="请输入单位名称"
                ></el-input>
              </el-form-item>
              <div class="prompt">请对比单位名称识别的准确性</div>
            </el-col>
            <el-col :span="12" v-if="num == '21'">
              <el-form-item prop="name" label="法人姓名">
                <el-input
                    disabled
                    v-model="ruleForm.name"
                    placeholder="请输入法人姓名"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="num == '21'">
              <el-form-item prop="idCard" label="法人身份证号">
                <el-input
                    disabled
                    v-model="ruleForm.idCard"
                    placeholder="请输入法人身份证号"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label-width="0">
            <el-button class="next-button" type="primary" @click="submitForm('ruleForm')">认证</el-button>
          </el-form-item>

        </el-form>
      </el-card>
    </div>

    <Bottom></Bottom>
    <check-example ref="checkRef"></check-example>

    <identify
        v-if="visible"
        :visible.sync="visible"
        :ruleForm="ruleForm"
    />
  </div>

</template>

<script>
import Bottom from "@/components/Bottom.vue";
import Header from "@/components/Header.vue";
import CheckExample from "@/pages/register/components/CheckExample.vue";
import Identify from "@/pages/authentication/comonents/identify.vue";

export default {
  name: "index",
  components: {Identify, CheckExample, Header, Bottom},
  data() {
    var validCode = (rule, value, callback) => {
      let reg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      if (value === "") {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的统一社会信用代码"));
      } else {
        callback();
      }
    };

    return {
      num: '',
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      ruleForm: {},
      rules: {
        businessCreditCode: [{required: true, validator: validCode, trigger: ["blur", "change"]}],
        businessName: [
          {required: true, message: "请输入正确的单位名称", trigger: ["blur", "change"]},
        ],
        businessLicenseId: [
          {
            required: true,
            message: "请上传单位营业执照",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请检查信用代码是否正确",
            trigger: "change",
          },
        ],
        idCard: [
          {
            required: true,
            message: "请检查信用代码是否正确",
            trigger: "change",
          },
        ],
      },
      loading: false,

      srcList: [],
      imageLicenseId: "",
      visible: false,

      businessCode: null,
    };
  },
  methods: {
    submitForm() {
      this.$refs.ruleForm.validate((value) => {
        if (value) {
          this.visible = true
        }
      });
    },
    checkExampleDia() {
      this.$refs.checkRef.show("official");
    },
    request(base, type) {
      let params = {
        type: '' + type,
        imageBase64: base,
      };
      this.loading = true;
      this.$http.post(this.$api.register.upload, params).then((res) => {
        if (res.data.code == 200) {
          if (type == 2) {
            this.$set(this.ruleForm, "businessLicenseId", res.data.data.imageId);
            if (res.data.data.businessName) {
              this.$set(this.ruleForm, "businessName", res.data.data.businessName);
            }

            this.$set(this, "businessCode", res.data.data.businessCode ? res.data.data.businessCode : null);
            if (res.data.data.businessCode) {
              this.$set(this.ruleForm, "businessCreditCode", res.data.data.businessCode);
              let businessCreditCode = res.data.data.businessCode
              this.num = businessCreditCode.slice(2, 0 - (businessCreditCode.length - 4))
              if (this.num == '21') {
                this.getLegalPersonByCreditCode()
              }
            }
          }
          this.loading = false;
        } else {
          this.$message.error(res.data.msg);
          this.loading = false;
        }
      });
    },
    getBlur() {
      if (this.businessCode != this.ruleForm.businessCreditCode && this.businessCode) {
        this.businessCode = this.ruleForm.businessCreditCode
        this.getLegalPersonByCreditCode()
      } else {
        this.loading = false;
      }
    },
    getLegalPersonByCreditCode() {
      this.loading = true
      let params = {
        creditCode: this.ruleForm.businessCreditCode
      };
      this.$http.get(this.$api.authentication.getLegalPersonByCreditCode, params).then((res) => {
        if (res.data.code == 200) {
          this.$set(this.ruleForm, "name", res.data.data.name);
          this.$set(this.ruleForm, "idCard", res.data.data.idCard);
        } else {
          this.$set(this.ruleForm, "name", '');
          this.$set(this.ruleForm, "idCard", '');
          this.$message.error('未查询到法人信息,请检查信用代码是否准确!')
        }
        this.loading = false;
      });
    },
    handleBeforeUpload(file, type) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // 转换为Base64
      reader.onload = (e) => {
        this.imageLicenseId = e.target.result;
        let position = e.target.result.indexOf("base64");
        let lastIndex = position * 1 + 7;
        let base = e.target.result.slice(lastIndex);
        this.request(base, type);
      };
      return false; // 阻止默认上传行为
    },
    onChangeFront(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    checkImage(flag) {
      this.srcList = [];
      this.srcList.push(this.imageLicenseId);
      this.isShowPics = true;
    },
  }
}
</script>

<style scoped lang="less">
.box-card {
  width: 1200px;
}

.upload-image {
  display: flex;
  align-items: flex-start;
  margin-bottom: 22px;

  .top-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100px;
  }
}

.prompt {
  margin-top: -23px;
  font-size: 12px;
  text-align: left;
  padding-left: 150px;
  color: #409EFF;
  margin-bottom: 11px;
}

::v-deep .el-form-item__error {
  background-color: #ffffff;
  width: 100%;
  text-align: left !important;
}

.avatar-uploader {
  position: relative;
  width: 210px;
  height: 160px;
  margin-right: 30px;
  background: #f5f7fa;
  border: 1px solid #f5f5f5;

  .image-card {
    height: 100%;
  }

  .icon-check {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

::v-deep .el-upload {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
